import {StyleSheet} from 'react-native';
import Styles from '../../../Styles';
import {getDescriber} from 'src/components/elements/orderAhead/descriptor/DescriptorType';

const {getMenuListCompnentsFontFamily, recentOrdersHideDetailsColors} =
  getDescriber();

const smallImageWidth = 83;

export const styles = StyleSheet.create({
  container: {
    marginVertical: Styles.Spacing.m2 + Styles.Spacing.m1,
    marginHorizontal: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
    backgroundColor: '#FFFFFF',
    elevation: 1,
  },
  titleBar: {
    paddingHorizontal: Styles.Spacing.m2,
    paddingBottom: Styles.Spacing.m2 + Styles.Spacing.m1,
    paddingTop: Styles.Spacing.m1,
    alignItems: 'center',
    flexDirection: 'row',
  },
  showHideUnderLine: {
    alignSelf: 'flex-start',
    borderBottomColor: recentOrdersHideDetailsColors(),
    borderBottomWidth: 1,
  },
  showHideText: {
    marginTop: Styles.Spacing.m2,
    color: recentOrdersHideDetailsColors(),
    fontFamily: getMenuListCompnentsFontFamily(),
    fontSize: Styles.Fonts.f8,
  },
  hideText: {
    color: recentOrdersHideDetailsColors(),
    fontSize: Styles.Fonts.f1,
    fontFamily: getMenuListCompnentsFontFamily(),
    fontWeight: '700',
  },
  dateText: {
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
    color: Styles.Colors.PayNew.darkHuesBase04,
    marginTop: Styles.Spacing.m2,
  },
  titleContainer: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m2,
  },
  titleText: {
    fontSize: Styles.Fonts.f1,
    color: Styles.Colors.PayNew.black01,
    fontFamily: getMenuListCompnentsFontFamily(),
    fontWeight: '700',
    paddingTop: Styles.Spacing.m2,
    flex: 0.8,
  },
  sublistImage: {
    width: Styles.Spacing.m5 + Styles.Spacing.m1 + 1,
    height: Styles.Spacing.m5 - Styles.Spacing.m2 + 2,
    borderRadius: Styles.Spacing.m2,
  },
  imageContainer: {
    width: smallImageWidth,
    aspectRatio: 1.15,
    borderRadius: Styles.Spacing.m2,
    overflow: 'hidden',
  },
  parentImage: {
    width: smallImageWidth,
    height: 73,
    aspectRatio: 1.15,
  },
  itemRowParent: {
    flexDirection: 'row',
    flex: 1,
  },
  itemRowInnerParent: {
    flexDirection: 'row',
    flex: 1,
    marginVertical: Styles.Spacing.m2,
  },
  itemInnerRow: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: Styles.Spacing.m1,
    marginRight: Styles.Spacing.m2,
    marginLeft: Styles.Spacing.m2,
  },
  item: {
    marginLeft: Styles.Spacing.m2,
    color: Styles.Colors.PayNew.black01,
    alignSelf: 'flex-start',
    fontSize: Styles.Fonts.f1,
    marginRight: Styles.Spacing.m2,
    fontWeight: 'bold',
    flex: 0.8,
  },
  itemPrice: {
    alignSelf: 'flex-end',
    color: Styles.Colors.PayNew.black01,
    fontSize: Styles.Fonts.f8,
    fontWeight: 'bold',
    fontFamily: getMenuListCompnentsFontFamily(),
  },
  inneritemPrice: {
    alignSelf: 'flex-end',
    color: Styles.Colors.PayNew.black01,
    fontSize: Styles.Fonts.f8,
    fontWeight: 'bold',
    fontFamily: getMenuListCompnentsFontFamily(),
    marginRight: Styles.Spacing.m2,
  },
  itemRight: {
    marginRight: Styles.Spacing.m2,
    flexDirection: 'column',
    justifyContent: 'center',
  },
  itemCenter: {
    flex: 1,
    flexDirection: 'column',
  },
  modifierContainer: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m2,
    flexDirection: 'column',
  },
  modifierText: {
    color: Styles.Colors.PayNew.black01,
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
    flex: 0.8,
  },
  modifierPrice: {
    color: Styles.Colors.PayNew.black01,
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
  },
  unavailableWrapper: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: Styles.Spacing.m2 + Styles.Spacing.m1,
  },
  unavailable: {
    color: Styles.dangerColor,
    fontSize: Styles.Fonts.f12,
    fontFamily: getMenuListCompnentsFontFamily(),
    fontWeight: '700',
  },
  unavailableModifier: {
    textDecorationStyle: 'solid',
    textDecorationColor: Styles.dangerColor,
    textDecorationLine: 'line-through',
  },
  totalLabel: {
    fontSize: Styles.Fonts.f8,
    fontFamily: getMenuListCompnentsFontFamily(),
    color: Styles.Colors.PayNew.black01,
    fontWeight: '700',
    marginTop: Styles.Spacing.m1,
    marginLeft: Styles.Spacing.m2,
    alignSelf: 'flex-start',
    marginRight: Styles.Spacing.m2,
  },
  reorderButton: {
    height: Styles.Spacing.m4,
    paddingHorizontal: Styles.Spacing.m2 + Styles.Spacing.m1,
  },
  rowStyle: {flex: 1, flexDirection: 'row', justifyContent: 'space-between'},
  divider: {
    borderBottomColor: Styles.Colors.PayNew.neutralHuesBase09,
    borderBottomWidth: 1,
    marginHorizontal: Styles.Spacing.m2,
    marginVertical: Styles.Spacing.m2,
  },
  modifierRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: Styles.Spacing.m2,
    marginTop: Styles.Spacing.m1,
  },
  innerBtnContainer: {
    marginRight: Styles.Spacing.m1,
  },
  modifierPriceRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  marginTotal: {
    marginTop: Styles.Spacing.m1,
  },
});
